export const padNumberUserId = (id: number, prefix: string = 'L', totalLength: number = 6) => {
  if (!id) return '';
  const zeros = new Array(totalLength).fill(0).join('');
  return `${id}`.length >= totalLength
    ? `${prefix} + ${id}`
    : `${prefix}${(zeros + id).slice(totalLength * -1)}`;
};

export const getInitials = (name: string): string => {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '';
  const [first, second] = words;
  if (!second) return first!.charAt(0).toUpperCase();
  return (first!.charAt(0) + second.charAt(0)).toUpperCase();
}